"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  alignment-baseline: middle;\n  dominant-baseline: middle;\n  text-transform: uppercase;\n  user-select: none;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var SVGTextBase = function SVGTextBase(props) {
  return _react.default.createElement("text", (0, _extends2.default)({
    x: "50",
    width: "100%"
  }, props));
};

var _default = (0, _styledComponents.default)(SVGTextBase).withConfig({
  displayName: "SVGTextStyle",
  componentId: "sc-3qu6jq-0"
})(_templateObject());

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-avatars/static-2.2401/js/UIAvatarDisplay/baseStyledComponents/SVGTextStyle.js
// module id = 423
// module chunks = 209 210 211 212